// @ts-nocheck

import React from 'react';
import styled, { css, keyframes } from 'styled-components';

import imagePath from '../../../../assets/img/grids/gridSinge.png';
import { Target } from '../../../../client';
import Formatter from '../../../../i18n/formatter';
import { __, getCurrency } from '../../../../i18n/l10n';
import GridsBasketButtonContainer from '../../containers/basket/GridsBasketButtonContainer';
import { GridTypes } from '../../types';
import type { GridType } from '../../types';

import StakeLabel from './StakeLabel';

const appear = keyframes`
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
`;

const Wrap = styled.div`
  text-align: center;
  padding: 1em;
  margin: 0;
  width: 100%;
`;

const CheckIcon = styled.svg`
  width: 3em;
  height: 3em;
  padding: 0.6em;
  border-radius: 50%;
  border: solid 2px ${({ theme }) => theme.grids.colors.greenwin};
  stroke: ${({ theme }) => theme.grids.colors.greenwin};
  fill: none;
  margin: 1em auto;
  animation: ${appear} 500ms cubic-bezier(0.64, 2.05, 0.63, 1) forwards;
`;

const Title = styled.h4`
  text-transform: uppercase;
  margin: 0;
`;

const Text = styled.p`
  margin: 0;
`;

const LabelStake = styled.p`
  margin: 0;
  color: ${({ theme }) => (Target.__MOBILE__ ? theme.grids.colors.middlegrey3 : theme.grids.colors.black)};
`;

const StyleStake = styled(StakeLabel)`
  text-align: center;
  margin: 0.6em 0 0;
  ${({ theme }) =>
    !Target.__MOBILE__
      ? css`
          color: ${theme.grids.colors.black};
        `
      : undefined};
`;

const Img = styled.div`
  background-image: url(${({ $image }) => $image});
  background-size: 100% auto;
  background-position: center;
  border-radius: 50%;
  width: 7em;
  height: 7em;
  margin: 2em auto;
`;

const StyledGridsBasketButtonContainer = styled(GridsBasketButtonContainer)`
  padding: 1em 0 0;
`;

type GridsValidatedViewProps = {
  className?: string;
  stake: number | null;
  gridReference?: string;
  gridPrice: number;
  gridType: GridType;
};

const GridsValidatedView = ({ className, stake, gridReference, gridPrice, gridType }: GridsValidatedViewProps) => {
  return (
    <Wrap className={className}>
      <CheckIcon viewBox="0 0 11 6">
        <path d="M 0 3 L 3 6 L 11 0" />
      </CheckIcon>
      <Title>{__('Congratulations!')}</Title>
      <Text>
        {gridReference || gridType === GridTypes.TEAM
          ? __('Your %1$s bet has been validated', Formatter.formatNumber(stake ?? 1, getCurrency(), true))
          : __('Your grid has been validated.')}
      </Text>
      <Img $image={imagePath} />
      <LabelStake>{__('Grid price')}</LabelStake>
      <StyleStake stake={gridPrice} />
      {!Target.__MOBILE__ ? <StyledGridsBasketButtonContainer gridReference={gridReference} /> : null}
    </Wrap>
  );
};

export default GridsValidatedView;
